export default __webpack_public_path__ + "static/media/danger.f7372347.svg";